export default __webpack_public_path__ + "assets/icons/iconSupport.fe2aa977.svg";